import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './ViewActions.module.css';

const bindClasses = classNameBind.bind(styles);

const ViewActions = ({
  isFloating = false,
  children,
  fullWidth = false,
}) => (
  <div
    className={bindClasses('outer', { floating: isFloating, fullWidth })}
    data-ppuc-id="ViewActions"
  >
    <div className={bindClasses('inner')}>
      {children}
    </div>
  </div>
);

ViewActions.displayName = 'View.Action';

export default ViewActions;
